module.exports = __webpack_public_path__ + "static/media/association.c509807a.png";